<template>
  <section class="listing">
    <div class="header">
      <div class="title">Eventos</div>
      <button @click="$router.push('/event/new')" class="button-new"><i class="fas fa-plus"></i><span>NOVO</span></button>
    </div>
    <form @submit.prevent class="form form-search">
      <date-picker v-model="period" @change="getData" type="date" range placeholder="Selecione um período" format="DD/MM/YYYY"></date-picker>
      <div class="search-input">
        <input v-model="search" type="text" placeholder="Pesquisar..." />
        <i class="fas fa-search show-search"></i>
      </div>
      <label class="switch" style="margin: 5px">
        <input @change="getData" v-model="canceled" type="checkbox">
        <span class="slider"></span>
        <span class="text">Cancelados</span>
      </label>
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <!-- VALIDAR -->
        <div v-if="validate.length" class="list-title">Responder</div>
        <div v-for="(show, index) in validate" :key="show.id" class="list">
          <div v-if="index > 0 ? getDay(show.date) !== getDay(shows[index - 1].date) : true" class="calendar">
            <span>{{ getDay(show.date) }}</span>
            <span>{{ getMonthText(show.date) }}</span>
          </div>
          <div v-if="index > 0 ? getDay(show.date) === getDay(shows[index - 1].date) : false" style="width: 50px"></div>
          <div class="time-text">
            <span>{{ getHours(show.date) }}</span>
            <span>{{ getMinutes(show.date) }}</span>
          </div>
          <div class="data">
            <div class="main-data">{{ show.name }}</div>
            <div class="detail-data">{{ `${show.duration}min | ${show.type}` }}</div>
          </div>
          <div class="actions">
            <button @click="$router.push(`/event/${show.id}`)" type="button" class="button-action">
              <i class="fas fa-pen"></i><span>ALTERAR</span>
            </button>
            <button @click="preview = show.show" class="button-action" style="margin-left: 5px">
              <i class="fas fa-eye"></i><span>VISUALIZAR</span>
            </button>
            <button v-if="show.sold === 0" @click="cancel = show" class="button-action" style="margin-left: 5px">
              <i class="fas fa-trash-alt"></i><span>CANCELAR</span>
            </button>
            <button @click="validation = show.id" class="button-action" style="margin-left: 5px">
              <i class="fas fa-comment-dots"></i><span>VALIDAÇÃO</span>
            </button>
          </div>
        </div>
        <!-- AGUARDANDO -->
        <div v-if="waiting.length" class="list-title">Aguardando aprovação...</div>
        <div v-for="(show, index) in waiting" :key="show.id" class="list">
          <div v-if="index > 0 ? getDay(show.date) !== getDay(shows[index - 1].date) : true" class="calendar">
            <span>{{ getDay(show.date) }}</span>
            <span>{{ getMonthText(show.date) }}</span>
          </div>
          <div v-if="index > 0 ? getDay(show.date) === getDay(shows[index - 1].date) : false" style="width: 50px"></div>
          <div class="time-text">
            <span>{{ getHours(show.date) }}</span>
            <span>{{ getMinutes(show.date) }}</span>
          </div>
          <div class="data">
            <div class="main-data">{{ show.name }}</div>
            <div class="detail-data">{{ `${show.duration}min | ${show.type}` }}</div>
          </div>
          <div class="actions">
            <button @click="$router.push(`/event/${show.id}`)" type="button" class="button-action">
              <i class="fas fa-pen"></i><span>ALTERAR</span>
            </button>
            <button @click="preview = show.show" class="button-action" style="margin-left: 5px">
              <i class="fas fa-eye"></i><span>VISUALIZAR</span>
            </button>
            <button v-if="show.sold === 0" @click="cancel = show" class="button-action" style="margin-left: 5px">
              <i class="fas fa-trash-alt"></i><span>CANCELAR</span>
            </button>
            <button @click="validation = show.id" class="button-action" style="margin-left: 5px">
              <i class="fas fa-comment-dots"></i><span>VALIDAÇÃO</span>
            </button>
          </div>
        </div>
        <!-- APROVADOS -->
        <div v-if="filtered.length" class="list-title">Aprovados</div>
        <ShowBordero
          v-if="showBordero"
          :id="selectedShow.id"
          :close="() => showBordero = false"
          :name="selectedShow.name"
          :date="selectedShow.date"
        />
        <div v-for="(s, i) in filtered" :key="s.id" class="list">
          <div v-if="i > 0 ? getDay(s.date) | getMonthText(s.date) !== getDay(shows[i - 1].date) | getMonthText(shows[i - 1].date) : true" class="calendar">
            <span>{{ getDay(s.date) }}</span>
            <span>{{ getMonthText(s.date) }}</span>
          </div>
          <!--<div v-if="i > 0 ? getDay(s.date) === getDay(shows[i - 1].date) : false" style="width: 50px"></div>-->
          <div class="time-text">
            <span>{{ getHours(s.date) }}</span>
            <span>{{ getMinutes(s.date) }}</span>
          </div>
          <div class="data">
            <div class="main-data">{{ s.name }}</div>
            <div class="detail-data">{{ `${s.duration}min | ${s.type}` }}</div>
          </div>
          <div class="actions">
            <button v-if="s.old" @click="$router.push(`/event/${s.id}/expense`)" type="button" class="button-action"><i class="fas fa-dollar-sign"></i><span>DESPESAS</span></button>
            <button v-if="!s.old && s.duration != Date.now()" @click="$router.push(`/event/${s.id}`)" type="button" class="button-action"><i class="fas fa-pen"></i><span>ALTERAR</span></button>
            <button v-if="!s.old && s.shortUrl" @click="share = s" type="button" class="button-action" style="margin-left: 5px"><i class="fas fa-share"></i><span>COMPARTILHAR</span></button>
            <button  @click="preview = s.show" type="button" class="button-action" style="margin-left: 5px"><i class="fas fa-eye"></i><span>VISUALIZAR</span></button>
            <button  v-if="id !== 'new'" @click="openBordero(s)" type="button" class="button-action" style="margin-left: 5px"><i class="fas fa-file-medical-alt"></i><span>BORDERÔ</span></button>
            <button v-if="s.sold === 0" @click="cancel = s" class="button-action" style="margin-left: 5px">
              <i class="fas fa-trash-alt"></i><span>CANCELAR</span>
            </button>
          </div>
        </div>
        <!-- CANCELADOS -->
        <div v-if="canceledFiltered.length" class="list-title">Cancelados</div>
        <div v-for="(s, i) in canceledFiltered" :key="s.id" class="list">
          <div v-if="i > 0 ? getDay(s.date) !== getDay(showsCanceled[i - 1].date) : true" class="calendar">
            <span>{{ getDay(s.date) }}</span>
            <span>{{ getMonthText(s.date) }}</span>
          </div>
          <div v-if="i > 0 ? getDay(s.date) === getDay(showsCanceled[i - 1].date) : false" style="width: 50px"></div>
          <div class="time-text">
            <span>{{ getHours(s.date) }}</span>
            <span>{{ getMinutes(s.date) }}</span>
          </div>
          <div class="data">
            <div class="main-data">{{ s.name }}</div>
            <div class="detail-data">{{ `${s.duration}min | ${s.type}` }}</div>
          </div>
          <div class="actions">
            <button @click="undoCancel(s.id)" type="button" class="button-action"><i class="fas fa-undo"></i><span>HABILITAR</span></button>
          </div>
        </div>
      </div>
    </transition>
    <Show v-if="!loading && show" :id="show" />
    <ShowExpense v-if="!loading && expense" :showDate="expense" />
    <ShowPreview v-if="preview" :show="preview" :business="business.url" :close="() => this.preview = null" />
    <ShowValidation v-if="validation" :showDate="validation" role="business" :close="() => this.validation = null" />
    <ShowCancel v-if="cancel" :show="cancel" :close="() => this.cancel = null" />
    <ShowShare v-if="share" :show="share" :close="() => this.share = null" />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getAll, getCanceled, undoCancel } from '../api/showDate'
import Show from './Show.vue'
import ShowExpense from './ShowExpense.vue'
import ShowPreview from './ShowPreview.vue'
import { getShows as getNotValidated } from '../api/showValidation'
import ShowValidation from './ShowValidation.vue'
import ShowCancel from './ShowCancel.vue'
import ShowBordero from './ShowBordero.vue'
import ShowShare from './ShowShare.vue'

export default {
  name: 'shows',
  components: { Show, ShowExpense, ShowPreview, ShowValidation, ShowCancel, ShowBordero, ShowShare },
  props: ['id'],
  data () {
    return {
      loading: true,
      show: null,
      shows: [],
      expense: null,
      period: [],
      search: '',
      preview: null,
      cancel: null,
      notValidated: [],
      validation: null,
      canceled: false,
      showsCanceled: [],
      showBordero: false,
      selectedShow: null,
      share: null
    }
  },
  computed: {
    ...mapState(['business']),
    filtered () {
      return this.shows.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    },
    canceledFiltered () {
      return this.showsCanceled.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    },
    validate () {
      return this.notValidated
        .filter(x => x.lastMessage === 'admin')
        .filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    },
    waiting () {
      return this.notValidated
        .filter(x => !x.lastMessage || x.lastMessage === 'business')
        .filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  watch: {
    async '$route' (value) {
      this.show = value.name === 'show-id' ? value.params['id'] : null
      this.expense = value.name === 'show-expense' ? value.params['id'] : null
      // Update list
      if (!value.params['id']) {
        this.getData()
      }
    },
    validation (value) {
      if (!value) {
        this.getData()
      }
    }
  },
  async mounted () {
    try {
      this.period = []
      this.period.push(new Date())
      this.period.push(new Date(new Date().setDate(new Date().getDate() + 365)))
      this.getData()
    } catch (error) {
      logger.error(error, this)
    }
    this.loading = false
  },
  methods: {
    openBordero (show) {
      this.selectedShow = show
      this.showBordero = true
    },
    async getData () {
      if (this.period.length === 0) return false
      this.loading = true
      try {
        const results = await Promise.all([
          getAll(this.period[0], this.period[1]),
          getNotValidated()
        ])
        this.shows = results[0] || []
        this.notValidated = results[1] || []
        if (this.canceled) this.showsCanceled = await getCanceled(this.period[0], this.period[1])
        else this.showsCanceled = []
      } catch (error) {
        logger.warn(error)
      }
      this.loading = false
    },
    async undoCancel (id) {
      try {
        await undoCancel(id)
        this.getData()
      } catch (error) {
        logger.error(error, this)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.list-title {
  border: 1px solid $primary-color;
  border-radius: 5px;
  // color: $primary-color;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  color: #fff;
  padding: 5px 10px;
  margin: 15px 0 5px;
}

.form-search {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  padding-bottom: 10px;

  .search-input input {
    width: 100%;
    height: 34px;
    margin: 5px;
  }

  .search-input {
    flex: 1;
    min-width: 200px;
    position: relative;
    margin: 5px;
    input {
      display: block;
      width: 100%;
      margin: 0;
    }
    i {
      position: absolute;
      top: 6px;
      right: 10px;
      color: #999;
      font-size: 1.5em;
    }
  }
}

.calendar {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 500;
  span:nth-child(1) {
    font-size: 1.2em;
  }
  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.time-text {
  font-size: 2.2em;
  font-weight: 400;
  padding-right: 20px;
  color: #555;
  display: flex;
  span:nth-child(2) {
    font-size: 0.5em;
    line-height: 2em;
  }
}

@media screen and (min-width: $desktop-width) {

  .form-search {
    input {
      width: auto;
    }
  }

}
</style>
